import styled from "styled-components"

export const LayoutContainer = styled.div`
    display: flex;
    flex-direction: column;
    color: white;
    position: relative;
    min-height: 100vh;
`;